<template>
  <a-modal
    :title="title"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('roleManagement.userManagement')" prop="userIds">
        <a-select
          v-model="form.userIds"
          mode="multiple"
          :placeholder="$t('roleManagement.searchUserPlaceholder')"
          :filterOption="filterUserOption"
          showSearch
        >
          <a-select-option 
            v-for="user in userOptions"
            :key="user.value"
            :value="user.value"
            :disabled="user.disabled"
          >
            {{ user.label }}{{ user.disabled ? ` (${$t('roleManagement.addUser')})` : '' }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { teacherList } from '@/api/admin'
import { i18nRender } from '@/locales'

export default {
  name: 'AddUserModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default() {
        return i18nRender('roleManagement.addUser')
      }
    },
    selectedUserIds: {
      type: Array,
      default: () => []
    },
    externalData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        userIds: []
      },
      rules: {
        userIds: [{ required: true, type: 'array', message: i18nRender('roleManagement.roleNameRequired'), trigger: 'change' }]
      },
      userOptions: []
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getUserList()
      } else {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields()
      this.form.userIds = []
    },
    handleCancel() {
      this.$emit('cancel')
      this.resetForm()
    },
    async handleOk() {
      try {
        const valid = await this.$refs.form.validate()
        if (valid) {
          this.confirmLoading = true
          // 获取选中用户的完整信息
          const selectedUsers = this.form.userIds.map(id => {
            const user = this.userOptions.find(option => option.value === id)
            if (user) {
              return {
                id: user.value,
                name: user.originalData.name,
                username: user.originalData.username,
                status: user.originalData.status || 1
              }
            }
            return null
          }).filter(Boolean)

          this.$emit('success', selectedUsers)
          this.resetForm()
        }
      } catch (error) {
        console.error(this.$t('roleManagement.addUserError'), error)
      } finally {
        this.confirmLoading = false
      }
    },
    async getUserList() {
      try {
        const res = await teacherList({
          status: 1,
          filterRole: true
        })
        if (res.code === 200 && res.data) {
          // 保存原始数据，并标记已添加的用户
          this.userOptions = res.data.list.map(user => ({
            label: `${user.name} (${user.username || '无账号'})`,
            value: user.id,
            disabled: this.externalData.some(existingUser => existingUser.id === user.id),
            originalData: user // 保存原始数据
          }))
        }
      } catch (error) {
        console.error('获取用户列表失败:', error)
        this.$message.error(this.$t('roleManagement.getUserListFailed'))
      }
    },
    filterUserOption(input, option) {
      if (!input || !option || !option.componentOptions || !option.componentOptions.children) {
        return true
      }
      const text = option.componentOptions.children[0].text || ''
      return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-select {
  width: 100%;
}
</style>